export default "__VITE_ASSET___HjiFp$R__"